import Analytics from "@mui/icons-material/Analytics";
import { Button, Stack, Typography } from "@mui/material";

import { useSidePanelTabPrefs } from "components/PlotMap/hooks/useSidePanelTabPrefs";

interface GoToPlotsPromptProps {
  header: string;
  message: string;
}

const GoToPlotsPrompt: React.FC<GoToPlotsPromptProps> = ({
  header,
  message,
}) => {
  const { setTabPrefs } = useSidePanelTabPrefs();

  const handleGoToPlots = () => {
    setTabPrefs({ isOpen: true, tab: "plt" });
  };

  return (
    <Stack spacing={1.5} sx={{ alignItems: "center", textAlign: "center" }}>
      <Analytics color="disabled" sx={{ fontSize: 48 }} />
      <Typography
        component="h3"
        sx={{ fontWeight: "bold" }}
        variant="subtitle1"
      >
        {header}
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 360 }} variant="body2">
        {message}
      </Typography>
      <Button
        aria-label="Go to plots tab"
        onClick={handleGoToPlots}
        variant="contained"
      >
        Go To Plots
      </Button>
    </Stack>
  );
};

export default GoToPlotsPrompt;
